import styled from '@emotion/styled';

export const Container = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 12px 16px;
	background-color: #fff3e0;
	border-radius: 4px;
	margin: 8px 16px;

	img {
		width: 20px;
		height: 20px;
	}

	p {
		font-size: 13px;
		color: #333;
		margin: 0;
	}
`;
